import { Form, Space, Switch, TableColumnType } from "antd";
import moment from "moment";
import React from "react";
import { CategoryName } from "../../../models/category";
import { Dimen } from "../../../models/dimen";
import { Checks } from "../../../models/setting";
import styles from "./supperDealing.module.css";

// 药品往来
export const SupplierDealingColumns = (
  startIndex: number,
  settings: any
): TableColumnType<any>[] => {

  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const spec = item.spec ? item.spec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? '/' + item.model : ''

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 生产厂家 + 包装规格 + 剂型 
        return tenantSupplierName + '/' + packSpec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 包装规格 + 型号
        return tenantSupplierName + '/' + packSpec + model
      } else {
        // 生产厂家 + 包装规格 
        return tenantSupplierName + '/' + packSpec
      }
    } else {
      if (materialsCategory == '0') {
        // 生产厂家 + 规格 + 剂型 
        return tenantSupplierName + '/' + spec + '/' + doseCategory
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 生产厂家 + 规格 +  型号 
        return tenantSupplierName + '/' + spec + model
      } else {
        // 生产厂家 + 规格 
        return tenantSupplierName + '/' + spec
      }
    }
  }

  return [
    {
      title: "序号",
      align: "center",
      width: Dimen.Num,
      key: "no",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "业务单号",
      align: "center",
      width: Dimen.PutNumber,
      dataIndex: "putNumber",
      key: "putNumber",
      sorter: (a: any, b: any) => a.putNumber - b.putNumber,
    },

    {
      title: "供应商名称",
      align: "center",
      dataIndex: "companyName",
      width: Dimen.SupplierName,
      key: "companyName",
      sorter: (a: any, b: any) => a.companyName.length - b.companyName.length,
    },
    {
      title: "商品信息",
      align: "left",
      dataIndex: "name",
      key: "",
      render: function Element(_, record) {
        return (
          <div style={{ height: "55px" }}>
            <p
              className={styles.nameText}
            >
              {record.name}
            </p>
            <p
              className={styles.productText}
            >
              {getProcuctInfo(record)}
            </p>
          </div>
        );
      },
      sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: "业务类别",
      align: "center",
      dataIndex: "category",
      width: Dimen.Category,
      key: "category",
      render: (_, t) => {
        return CategoryName(t.category);
      },
      sorter: (a: any, b: any) => a.category.length - b.category.length,
    },
    {
      title: "发生日期",
      align: "center",
      dataIndex: "createTime",
      width: Dimen.Time,
      key: "createTime",
      render: (_, t) => {
        const createTime = t.createTime.substring(0, 10);
        return createTime;
      },
      sorter: (a: any, b: any) =>
        moment(a.createTime).unix() - moment(b.createTime).unix(),
    },

    {
      title: "数量",
      align: "center",
      dataIndex: "count",
      width: Dimen.Count,
      key: "count",
      sorter: (a: any, b: any) => a.count - b.count,
    },
    {
      title: "成本价",
      align: "right",
      dataIndex: "unitPrice",
      width: Dimen.Price,
      key: "unitPrice",
      render: (_: any, t: any) => {
        return t.unitPrice
          ? parseFloat((t.unitPrice as unknown) as string).toFixed(5)
          : 0;
      },
    },
    {
      title: "总金额",
      align: "right",
      dataIndex: "totalPrice",
      width: Dimen.Price,
      key: "totalPrice",
      render: (_: any, t: any) => {
        return t.totalPrice
          ? parseFloat((t.totalPrice as unknown) as string).toFixed(2)
          : 0;
      },
    },
  ];
};
